<template>
  <!--
        这个页面有是那种状态：1. 初次绑定；2.更新邮箱 3.绑定成功
        初次绑定流程： 1.给邮箱发送验证码 --》 2.提交验证码 --》 3.显示绑定成功提示
        更新邮箱流程： 1.验证旧邮箱(通过验证码验证) --》2. 给新邮箱发验证码 --》3. 新邮箱验证码
        绑定成功: 1.显示绑定成功提示 --》2.邮件发送倒计时1分钟结束后，显示重新验证邮箱的按钮--》点击按钮，回到验证旧邮箱流程
  -->
  <Block type="accountSetting" id="safeQuession">
    <common-header
      is-passport
      :show-back="!isSDK"
      :show-lang="!isSDK"
      :title="accountLanguages.bindEmail"
    ></common-header>
    <!-- 绑定邮箱/更新邮箱的时候显示 -->
    <BindEmailForm
      :languages="accountLanguages"
      :email="email"
      :ckcode="ckcode"
      :type="bindEmailType"
      :terms="terms"
      @sendVrCode2Email="sendVrCode2Email"
      @submit="bindEmail"
      @selectTerm="selectTerm"
      v-if="bindEmailStatus_never"
    ></BindEmailForm>
    <!-- 验证旧邮箱的时候显示 -->
    <ValidateEmailForm
      :languages="accountLanguages"
      :accountEmail="accountEmail"
      :terms="terms"
      @submit="validateEmail"
      @sendVrCode2Email="sendVrCode2Email"
      v-if="bindEmailStatus_binded"
    ></ValidateEmailForm>
    <!-- 绑定／update 邮箱的时候显示 -->
    <SubmitSuccessTips
      v-if="bindEmailStatus_bindingSuccess"
      :tips="rebindTips"
    ></SubmitSuccessTips>
    <Block
      tagName="label"
      type="editorWrapper"
      name="resetEmailBtn"
      v-if="bindState === BIND_STATE_BIND_SUCCESS && sendedVrCode1minAgo"
      class="agree-wrapper rebind-email"
      :class="$platformClass"
    >
      <!-- <Button
        data-asyncbtn
        class="btn account-setting-submit"
        type="button"
        @click="rebind"
      >{{languages.rebindEmail}}</Button> -->
      <Button
        class="btn account-setting-submit"
        :type="$isOmni ? 'lightfill' : 'fillLight'"
        data-asyncbtn
        @click="rebind"
      >
        <Icon type="commonBtnLeft"></Icon>
        <Icon type="commonBtnRight"></Icon>
        {{ accountLanguages.rebindEmail }}
      </Button>
    </Block>

    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="accountLanguages"
      :content="errTips"
    ></PopupWindow>
    <transition name="fade">
      <LoaddingPage v-show="loadding"></LoaddingPage>
    </transition>
  </Block>
</template>
<script>
import {
  GET_VERIFFY_CODE,
  BIND_EMAIL,
  VERIFY_EMAIL,
  LOAD_EXTEND_INFO,
} from '../../store/passport/accountSetting';
import { EventBus } from '../../utiles';
import AccountSettingMixins from '../../mixins/AccountSetting';
import ValidateEmailForm from '../../components/passport/ValidateEmailForm';
import {
  COUNT_DOWN_FINISH,
  START_COUNT_DOWN_EVT,
  REET_STATUS,
} from '../../components/passport/AcountDownBtn';
import BindEmailForm, {
  FORM_TYPE_BIND_EMIAL,
  FORM_TYPE_UPDATE_EMAIL,
} from '../../components/passport/BindEmailForm';
import commonHeader from '@/resource/components/support/header';
import globalConfig from '../../utiles/globalConfig';
const BIND_STATE_UNBIND = 'unbind';
const BIND_STATE_BINDED = 'binded';
const BIND_STATE_BIND_SUCCESS = 'bindSuccess';
export default {
  name: 'bindEmail',
  data() {
    return {
      email: '',
      terms: true,
      ckcode: '',
      sendedVrCode1minAgo: true,
      showRebind: false,
      updateEmail: false,
      BIND_STATE_UNBIND,
      BIND_STATE_BINDED,
      BIND_STATE_BIND_SUCCESS,
      bindEmailType: FORM_TYPE_BIND_EMIAL,
      isSDK: false,
    };
  },
  computed: {
    rebindTips() {
      return this.accountLanguages.bindEmailSuccess.replace(
        '$email',
        this.$store.state.account.email
      );
    },
    accountEmail() {
      return this.$store.state.account.email;
    },
    bindedEmail() {
      return this.$store.state.account.isBindEmail;
    },
    bindEmailStatus_never() {
      return (!this.submitSuccess && !this.bindedEmail) || this.showRebind;
    },
    bindEmailStatus_binded() {
      return !this.submitSuccess && this.bindedEmail && !this.showRebind;
    },
    bindEmailStatus_bindingSuccess() {
      return this.submitSuccess && this.bindedEmail;
    },
    bindState() {
      if ((!this.submitSuccess && !this.bindedEmail) || this.showRebind) {
        return BIND_STATE_UNBIND;
      }
      if (!this.submitSuccess && this.bindedEmail && !this.showRebind) {
        return BIND_STATE_BINDED;
      }
      if (this.submitSuccess && this.bindedEmail) {
        return BIND_STATE_BIND_SUCCESS;
      }
      return BIND_STATE_BINDED;
    },
  },
  methods: {
    /**
     * @param 有三种场景需要发送
     * 1.初次绑定
     * 2.验证已经绑定的邮箱
     * 3.更新邮箱
     */
    sendVrCode2Email({ ref, email }) {
      this.showLoadding();
      this.$store
        .dispatch(GET_VERIFFY_CODE, {
          email,
          ref,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true,
        })
        .then(() => {
          this.hideLoadding();
          EventBus.$emit(START_COUNT_DOWN_EVT);
          this.sendedVrCode1minAgo = false;
        })
        .catch(err => {
          this.hideLoadding();
          this.showErrorTips(err.message);
        });
      EventBus.$on(COUNT_DOWN_FINISH, () => {
        this.sendedVrCode1minAgo = true;
      });
    },
    bindEmail({ email, ref, ckcode }) {
      this.showLoadding();
      this.$store
        .dispatch(BIND_EMAIL, {
          ckcode: ckcode,
          email: email,
          terms: this.terms,
          ref: ref,
          rebind: false,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true,
        })
        .then(async success => {
          this.hideLoadding();
          if (success) {
            await this.$store.dispatch(LOAD_EXTEND_INFO);
            this.email = '';
            this.ckcode = '';
            this.showRebind = false;
            this.submitSuccess = true;
          }
        })
        .catch(err => {
          this.hideLoadding();
          this.showErrorTips(err.message);
        });
    },
    validateEmail(ckcode) {
      this.bindEmailType = FORM_TYPE_BIND_EMIAL;
      this.showLoadding();
      this.$store
        .dispatch(VERIFY_EMAIL, {
          ckcode,
          terms: this.terms,
          rebind: true,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true,
        })
        .then(async success => {
          this.hideLoadding();
          if (success) {
            await this.$store.dispatch(LOAD_EXTEND_INFO);
            this.email = '';
            this.ckcode = '';
            this.submitSuccess = false;
            this.showRebind = true;
            this.updateEmail = true;
            this.bindEmailType = FORM_TYPE_UPDATE_EMAIL;
            EventBus.$emit(REET_STATUS);
          }
        })
        .catch(err => {
          this.hideLoadding();
          this.showErrorTips(err.message);
        });
    },
    rebind() {
      this.reChange();
    },
  },
  created() {
    let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
    let isWeb = +globalConfig.getHrefParam('web') === 1;
    let isH5 = +globalConfig.getHrefParam('h5') === 1;
    this.isSDK = hasSdkToken || (isWeb && isH5);
  },
  mixins: [AccountSettingMixins],
  components: {
    ValidateEmailForm,
    BindEmailForm,
    commonHeader,
  },
};
</script>
